export default __webpack_public_path__ + "static/media/lerbin.d1045a92.svg";